module.exports = __webpack_public_path__ + "img/product_30.16e4584.webp";